// MarkerFunctions.ts

import { Context } from "konva/lib/Context";
import Konva from "konva";
import { Tag } from "konva/lib/shapes/Label";
import { CreateSegmentMarkerOptions } from "peaks.js";
import { getCssVariable } from "@/utils/utils.ts";
import Shape = Konva.Shape;

export const segmentTag = (
  id: string,
  options: CreateSegmentMarkerOptions,
  position: string
): Tag => {
  const isTop = position === 'top';
  const pointerDirection = isTop ? 'down' : 'up';

  return new Tag({
    id,
    offsetX: 7.5,
    pointerDirection: pointerDirection,
    pointerWidth: 15,
    pointerHeight: 15,
    /*shadowColor: 'black',
    shadowBlur: 5,
    shadowOffsetX: options.startMarker ? 1 : -1,
    shadowOffsetY: isTop ? 1 : -1,
    shadowOpacity: 0.2,*/
    hitFunc: function (context, shape) {
      context.beginPath();
      if (isTop) {
        context.moveTo(7.5, -7);
        context.lineTo(22.5, -7);
        context.lineTo(22.5, 22);
        context.lineTo(-7, 22);
        context.lineTo(-7, -7);
      } else {
        context.moveTo(7.5, 7);
        context.lineTo(22.5, 7);
        context.lineTo(22.5, -22);
        context.lineTo(-7, -22);
        context.lineTo(-7, 7);
      }
      context.closePath();
      context.fillStrokeShape(shape);
    },
    sceneFunc: function (context: Context) {
      context.beginPath();
      if (isTop) {
        context.moveTo(7.5, 0);
        if (options.startMarker) {
          context.lineTo(17, 0);
          context.lineTo(7.5, 11);
        } else {
          context.lineTo(-2, 0);
          context.lineTo(7, 11);
        }
      } else {
        context.moveTo(7.5, 0);
        if (options.startMarker) {
          context.lineTo(17, 0);
          context.lineTo(7.5, -11);
        } else {
          context.lineTo(-2, 0);
          context.lineTo(7, -11);
        }
      }

      context.fillStyle = getCssVariable('--mui-palette-action-active');
      context.fill();
      context.closePath();
    },
  });
};

export const arrowDownTag = (id: string, color: string): Tag => {
  return new Tag({
    id,
    fill: color,
    strokeWidth: 0,
    pointerDirection: 'down',
    pointerWidth: 15,
    pointerHeight: 15,
    lineJoin: 'round',
    /*shadowColor: 'black',
    shadowBlur: 5,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    shadowOpacity: 0.3,*/
    cursor: 'pointer',

    hitFunc: function (context: Context, shape: Shape) {
      context.beginPath();
      context.moveTo(7.5, -7); // Voeg extra ruimte boven de driehoek toe
      context.lineTo(22.5, -7); // Voeg extra ruimte boven de driehoek toe
      context.lineTo(22.5, 22); // Voeg extra ruimte rondom de driehoek toe
      context.lineTo(-7, 22); // Voeg extra ruimte rondom de driehoek toe
      context.lineTo(-7, -7); // Voeg extra ruimte boven de driehoek toe
      context.closePath();
      context.fillStrokeShape(shape);
    },
  });
};
